import MainMenu, { MainMenuProps } from './MainMenu';

export type { MainMenuProps };
export default MainMenu;
